import { useInfiniteQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { platformChatService } from '../../../services/PlatformChatService';
import { chatQueryKeys } from '../chatQueryKeys';
import { PLATFORM_CHAT_MESSAGES_PAGE_SIZE } from '../platformChatConstants';

export function usePlatformChatMessagesInfiniteQuery(
  sessionId: string,
  options?: { enabled?: boolean },
) {
  const { user } = useAuth();
  const isEnabled =
    (options?.enabled ?? true) && Boolean(user) && sessionId.length > 0;

  return useInfiniteQuery({
    queryKey: chatQueryKeys.messages(sessionId),
    enabled: isEnabled,
    initialPageParam: 0,
    queryFn: ({ pageParam }) =>
      platformChatService.listMessages(sessionId, {
        limit: PLATFORM_CHAT_MESSAGES_PAGE_SIZE,
        offset: pageParam,
      }),
    getNextPageParam: (lastPage, _allPages, lastPageParam) =>
      lastPage.length === PLATFORM_CHAT_MESSAGES_PAGE_SIZE
        ? (lastPageParam as number) + PLATFORM_CHAT_MESSAGES_PAGE_SIZE
        : undefined,
  });
}
